import { differenceInMinutes, fromUnixTime, isToday } from 'date-fns';

export const isAfterStartTimeOnStartDay = (saleStartTs: number) => {
    if (!saleStartTs) {
        return false;
    }
    const now = new Date();
    return isToday(fromUnixTime(saleStartTs)) && differenceInMinutes(now, fromUnixTime(saleStartTs)) >= 0;
};
